import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocationService, TutionLocation } from '../location.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';


@Component({
    selector: 'app-location-details',
    templateUrl: './location-details.component.html',
    styleUrls: ['./location-details.component.css'],
    standalone: false
})
export class LocationDetailsComponent implements OnInit {

  location: TutionLocation;
  safeMapUrl: SafeResourceUrl;
  activeFaqIndex: number = -1;

  constructor(
    private route: ActivatedRoute,
    private locationService: LocationService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const town = params['town'];
      this.location = this.locationService.getLocationByTown(town);
      
      if (this.location) {
        this.safeMapUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.location.mapUrl);
      }

      if (this.location) {
        this.safeMapUrl =
          this.sanitizer.bypassSecurityTrustResourceUrl(this.location.mapUrl);
      }
    });
  }

  toggleFaq(index: number) {
    this.activeFaqIndex = this.activeFaqIndex === index ? -1 : index;
  }

  isFaqActive(index: number): boolean {
    return this.activeFaqIndex === index;
  }
}
